
import React from 'react';
import { ProductRackFragment } from '../src/model/fragments';
import { ProductRackList } from './ProductRackList';
import { ProductRackMap } from './ProductRackMap';


interface ProductRackViewProps {
    racks: ProductRackFragment[]
}

export const ProductRackView: React.FunctionComponent<ProductRackViewProps> = ({
	racks
}) => {

    return <div className="productRackView">
        <ProductRackList racks={racks} mode='vendors' />
        <ProductRackMap racks={racks} />
    </div>;
}
